import React from 'react';
import { Pencil, Save, X } from 'lucide-react';

/**
 * Coloured section header with inline edit controls.
 * While editing, shows Save/Cancel icons. Otherwise shows a Pencil
 * edit button when `onEdit` is provided.
 */
export const SectionHeader = ({
  title,
  color = 'blue',
  onEdit,
  editing,
  onSave,
  onCancel,
  onTitleClick,
}) => (
  <div className="flex items-center justify-between mb-1">
    {onTitleClick ? (
      <button
        onClick={onTitleClick}
        className={`text-xs font-bold uppercase tracking-wider hover:underline cursor-pointer text-left ${
          color === 'blue' ? 'text-blue-600' : 'text-brand-red'
        }`}
        title="Zur Detailseite"
        data-testid={`section-link-${title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
      >
        {title}
      </button>
    ) : (
    <span
      className={`text-xs font-bold uppercase tracking-wider ${
        color === 'blue' ? 'text-blue-600' : 'text-brand-red'
      }`}
    >
      {title}
    </span>
    )}
    {editing ? (
      <div className="flex gap-1">
        <button
          onClick={onSave}
          className="p-1 text-emerald-600 hover:bg-emerald-50 rounded"
          data-testid={`section-save-${title.toLowerCase().replace(/\s+/g, '-')}`}
        >
          <Save className="w-4 h-4" />
        </button>
        <button
          onClick={onCancel}
          className="p-1 text-slate-400 hover:bg-slate-100 rounded"
          data-testid={`section-cancel-${title.toLowerCase().replace(/\s+/g, '-')}`}
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    ) : (
      onEdit && (
        <button
          onClick={onEdit}
          className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded"
          data-testid={`section-edit-${title.toLowerCase().replace(/\s+/g, '-')}`}
        >
          <Pencil className="w-3.5 h-3.5" />
        </button>
      )
    )}
  </div>
);

export default SectionHeader;
